import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { hooks as h } from "@/hooks";
import { Button } from "@patient-watch/ui/button";
import { ArrowLeft } from "lucide-react";
import { QuickstartPageContent } from "@/features/templates/components/QuickstartPageContent";

function QuickstartPage() {
    const navigate = useNavigate();

    h.useNav([
        { label: "Templates", route: { to: "/templates" } },
        { label: "Quickstart Page", route: { to: "/templates/quickstart-page" } },
    ]);

    return (
        <div className="space-y-6 mx-auto p-2 md:p-4 max-w-2xl">
            <div className="flex items-center gap-4">
                <Button variant="ghost" size="sm" onClick={() => void navigate({ to: "/templates" } as never)}>
                    <ArrowLeft className="mr-2 w-4 h-4" />
                    Back to Templates
                </Button>
            </div>
            <QuickstartPageContent />
        </div>
    );
}

export const Route = createFileRoute("/_app/templates/quickstart-page")({
    component: QuickstartPage,
});
